module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fastest.785489b5.svg";